export const LAST_CLEAN_SHIRT_SLUG = 'last-clean-shirt';

export function usesLastCleanShirtOcclusion(part) {
  return part?.slotKey === 'clothes_base' && part?.slug === LAST_CLEAN_SHIRT_SLUG;
}

export function usesSleevedArmOcclusion(part) {
  return usesLastCleanShirtOcclusion(part) || part?.slotKey === 'jacket';
}
